import { AppActionType } from '../actiontype/app.actiontype';

export function showLoader() {
    return { type: AppActionType.SHOW_LOADER, payload: true };
}

export function hideLoader() {
    return { type: AppActionType.HIDE_LOADER, payload: false };
}

export function showHeader() {
    return { type: AppActionType.SHOW_HEADER, payload: true };
}

export function hideHeader() {
    return { type: AppActionType.HIDE_HEADER, payload: false };
}

export function showFooter() {
    return { type: AppActionType.SHOW_FOOTER, payload: true };
}

export function hideFooter() {
    return { type: AppActionType.HIDE_FOOTER, payload: false };
}

export function setMsisdn(msisdn) {
    return { type: AppActionType.SET_MSISDN, payload: msisdn };
}